class toastAlertErros {
  validateErro(error, toast) {
    const erro = error.response.data.erros;

    for (var i = 0; i < erro.length; i++) {
      toast.open({
        message: Object.values(erro[i]).toString().replace("id", ""),
        type: "info",
      });
    }
  }

  validateMessage(error, toast) {
    const message = error.response.data.message;

    toast.open({
      message: message,
      type: "info",
    });
  }

  validateErroDoesNotContainFor(error, toast) {
    const erro = error.response.data.erros;
   
    toast.open({
      message: erro,
      type: "info",
    });
  }

  
validateErrorRemoveUnwantedCharacters(error, toast) {
    const erro = error.response.data.erros.replace('_', ' ')
   
    toast.open({
      message: erro,
      type: "info",
    });
  }
}

export default new toastAlertErros();
